import {AfterViewInit, Component, computed, inject, OnInit, signal, ViewChild} from "@angular/core";
import {CommonModule} from "@angular/common";
import {Router, RouterModule} from "@angular/router";
import {BootstrapIcon, HeaderService} from "../../services/header.service";
import {UserService} from "../../services/user.service";
import {ModalService} from "../../shared/data-access/modal.service";
import {SearchFilterBarComponent} from "../../shared/components/search-filter-bar/search-filter-bar.component";
import {CookieService} from "ngx-cookie-service";
import {WorkplaceAccessService} from "../workplaces/data-access/workplace-access.service";
import {KnowledgeBaseService} from "../knowledge-database/data-access/knowledge-base.service";
import {ApiService} from "../../services/api.service";
import {BehaviorSubject, combineLatest, forkJoin, map, startWith, switchMap} from "rxjs";
import {
  FilterInterfaceComponent,
  FilterParams
} from "../../shared/components/filter-interface/filter-interface.component";
import {MalfunctionStatus, Report} from "../../shared/interfaces/report";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ProductionLine} from "../../shared/interfaces/productionLine";
import {Userrole} from "../../shared/interfaces/user";
import {WorkplaceCardComponent} from "../workplaces/components/workplace-card/workplace-card.component";
import {ReportTableComponent} from "../dashboard/components/report-table/report-table.component";
import {PaginatorComponent} from "../../shared/components/paginator/paginator.component";

interface WorkplacesState {
  activeReports: Report[];
  reports: Report[];
  escalations: Report[];
  totalPages: number;
}

@Component({
  selector: "app-escalation",
  templateUrl: "./escalation.component.html",
  styleUrls: ["./escalation.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule, SearchFilterBarComponent, WorkplaceCardComponent, ReportTableComponent, PaginatorComponent, FilterInterfaceComponent],
})
export class EscalationComponent implements OnInit, AfterViewInit {
  headerService = inject(HeaderService)
  userService = inject(UserService)
  modalService = inject(ModalService)

  @ViewChild("searchBar") searchBar!: SearchFilterBarComponent;
  // @ViewChild("reportFilter") reportFilter!: FilterInterfaceComponent;

  displayedColumns: string[] = ["id", "time", "reason"];
  PAGE_SIZE = 5;

  Userrole = Userrole;
  BootstrapIcon = BootstrapIcon;
  router = inject(Router);
  cookieService = inject(CookieService);
  workplaceService = inject(WorkplaceAccessService);
  knowledgeBaseService = inject(KnowledgeBaseService);
  apiService = inject(ApiService);

  showFilterInterface = signal<boolean>(false);
  private searchTerm$ = new BehaviorSubject<string | null>("");
  protected filterValues$ = new BehaviorSubject<FilterParams | null>(null);
  private page$ = new BehaviorSubject<number>(1);
  private productionLineId$ = new BehaviorSubject<string | null>(null);

  private state = signal<WorkplacesState>({
    activeReports: [],
    reports: [],
    escalations: [],
    totalPages: 1,
  });

  activeReports = computed(() => this.state().activeReports);
  solvedReports = computed(() => this.state().reports);
  escalatedReports = computed(() => this.state().escalations);
  totalPages = computed(() => this.state().totalPages);

  ngOnInit(): void {
    this.headerService.setHeaderTitle('Eskalationen')
    this.headerService.setHeaderSubTitle('Gesamtübersicht')
    this.headerService.setBackgroundColor("#ffffff");
    this.headerService.setHeaderIcon(BootstrapIcon.escalation, 'text-qundis-orange')

    if (this.userService.userrole() === Userrole.Mitarbeiter) {
      this.workplaceService.selectedProductionLine$.next({
        id: this.cookieService.get("productionLine").split("%")[0],
        name: this.cookieService.get("productionLine").split("%")[1],
      });
    }
  }

  ngAfterViewInit() {
    this.searchBar.valueChange
      .pipe(
        startWith(""),
        map((searchTerm) => searchTerm || null)
      )
      .subscribe((value) => {
        this.searchTerm$.next(value);
      });
  }


  /*constructor() {
    combineLatest([
      this.productionLineId$,
      this.searchTerm$,
      this.filterValues$,
      this.page$,
    ])
      .pipe(
        switchMap(([selectedLineId, searchTerm, filterValues, page]) => {
          console.log(selectedLineId, searchTerm, filterValues, page);
          const rangeStart = (page - 1) * this.PAGE_SIZE;
          const rangeEnd = page * this.PAGE_SIZE;
          const filterConfig = {
            searchText: searchTerm,
            startDate: filterValues?.startDate,
            endDate: filterValues?.endDate,
            startTime: filterValues?.startTime,
            endTime: filterValues?.endTime,
            minDuration: filterValues?.minDuration,
            maxDuration: filterValues?.maxDuration,
          }
          if (!selectedLineId) {
            console.log("searching for reports in all productionLines");
            // return all productionLines
            return forkJoin({
              activeReports: this.apiService.getFilteredReports({
                ...filterConfig,
                statusFilter: [1, 3],
              }),
              reports: this.apiService.getFilteredReports({
                ...filterConfig,
                rangeStart: rangeStart,
                rangeEnd: rangeEnd,
                statusFilter: [MalfunctionStatus.SOLVED],
              }),
              escalations: this.apiService.getFilteredReports({
                ...filterConfig,
                statusFilter: [MalfunctionStatus.ESCALATED],
              })
            });
          } else {
            console.log(
              "searching for reports in productionLine",
              selectedLineId
            );

            // filter by productionLine
            return forkJoin({
              activeReports: this.apiService.getFilteredReports({
                ...filterConfig,
                productionLineFilter: Array(selectedLineId),
                statusFilter: [MalfunctionStatus.CREATED, MalfunctionStatus.ESCALATED],
              }),
              reports: this.apiService.getFilteredReports({
                ...filterConfig,
                productionLineFilter: Array(selectedLineId),
                rangeStart: rangeStart,
                rangeEnd: rangeEnd,
                statusFilter: [MalfunctionStatus.SOLVED],
              }),
              escalations: this.apiService.getFilteredReports({
                ...filterConfig,
                productionLineFilter: Array(selectedLineId),
                statusFilter: [MalfunctionStatus.ESCALATED],
              }),
            });
          }
        }),
        map(({activeReports, reports, escalations}) => ({
          activeReports: activeReports.reportData,
          reports: reports.reportData,
          escalations: escalations.reportData,
          rows: Math.ceil(reports.totalCount / this.PAGE_SIZE),
        })),
        takeUntilDestroyed()
      )
      .subscribe(({activeReports, reports, escalations, rows}) => {
        console.log(activeReports, reports);
        this.state.update((state) => ({
          ...state,
          activeReports,
          reports,
          escalations,
          totalPages: rows,
        }));
      });
  }*/

  onFilterValueChange(filterParams: FilterParams) {
    this.filterValues$.next(filterParams);
  }

  selectProductionLine(line: ProductionLine): void {
    this.productionLineId$.next(line.id!);
    this.workplaceService.selectedProductionLine$.next({
      id: line.id!,
      name: line.name!,
    });
    this.headerService.setHeaderSubTitle(line.name);
    this.resetFilteredReports();
  }

  selectWorkplace(id: string) {
    this.router.navigate(["/workplace", id], {queryParams: {module: 'escalation'}});
    this.resetFilteredReports();
  }

  setPage(page: number) {
    this.page$.next(page);
  }

  resetFilteredReports() {
    this.state.set({
      activeReports: [],
      reports: [],
      escalations: [],
      totalPages: 1,
    });
  }

  back() {
    if (this.workplaceService.selectedProductionLineSignal()?.id) {
      this.workplaceService.selectedProductionLine$.next(null);
      this.productionLineId$.next(null);
      this.showFilterInterface.set(false);
      this.headerService.setHeaderSubTitle("Gesamtübersicht");
    } else {
      this.router.navigate(["/dashboard"]);
    }
  }
}
